import { OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DashboardService } from '../dashboard';
var PrintProfileComponent = /** @class */ (function () {
    function PrintProfileComponent(dashboardService, router, route) {
        this.dashboardService = dashboardService;
        this.router = router;
        this.route = route;
        this.viewProfile = {};
        this.user = {};
        this.sub = {};
        this.query = {};
        this.userRcmd = [];
        this.getSkills = [];
        this.usergetSkills = [];
        this.allskills = [];
        this.coursebyMe = [];
        this.userprofiledata = [];
    }
    PrintProfileComponent.prototype.editDisplay = function (edit) {
        if (edit) {
            return "block";
        }
        else {
            return "none";
        }
    };
    PrintProfileComponent.prototype.ngOnInit = function () {
        var _this = this;
        console.log('inside ngOnInit()');
        this.sub = this.route.queryParams.subscribe(function (params) { _this.query = params['user'] || 0; });
        if (this.query == '0') {
            console.log('no query string');
            this.dashboardService.userSummary1().subscribe(function (data) { _this.user = data; }, function (error) { });
            this.dashboardService.viewProfile().subscribe(function (res) { _this.viewProfile = res; console.log(res); }, function (err) { return console.log(err); });
            this.dashboardService.userAccptRcmd().subscribe(function (res) { _this.userRcmd = res; }, function (err) { return console.log(err); });
            this.dashboardService.viewcourseByMe().subscribe(function (res) { _this.coursebyMe = res; }, function (err) { return console.log(err); });
            this.dashboardService.getSkills().subscribe(function (data) {
                _this.getSkills = data;
                _this.getSkills.forEach(function (val, ind, arr) {
                    _this.allskills.push(val.userSkillSetName);
                });
            }, function (err) { return console.log(err); });
        }
        else {
            this.dashboardService.profileVisitsbyId(this.query).subscribe(function (data) {
                console.log(data);
                _this.userprofiledata = data;
                _this.viewProfile.aboutMe = data.aboutMe;
                _this.viewProfile.campus = data.campus;
                _this.viewProfile.booksIRecommend = data.booksIRecommend;
                _this.viewProfile.coursesIRecommend = data.coursesIRecommend;
                _this.viewProfile.degreeCourse = data.degreeCourse;
                _this.viewProfile.eduIns = data.eduIns;
                _this.viewProfile.firstName = data.firstName;
                _this.viewProfile.lastName = data.lastName;
                _this.viewProfile.profilepicName = data.profilepicName;
                _this.viewProfile.middleName = data.middleName;
                _this.viewProfile.myInterests = data.myInterests;
                _this.viewProfile.noOfAlumniCOnnections = data.noOfAlumniCOnnections;
                _this.viewProfile.noOfProfessorConnections = data.noOfProfessorConnections;
                _this.viewProfile.noOfStudentConnections = data.noOfStudentConnections;
                _this.viewProfile.pastEducations = data.pastEducations;
                _this.viewProfile.projectResearchWorkExp = data.projectResearchWorkExp;
                _this.allskills = data.specialties;
                if (_this.allskills != null) {
                    _this.allskills.forEach(function (val, ind, arr) {
                        _this.usergetSkills.push(val);
                    });
                    console.log(_this.usergetSkills);
                }
                _this.viewProfile.subject = data.subject;
                _this.viewProfile.userDetailsId = data.userDetailsId;
                _this.viewProfile.userType = data.userType;
                _this.dashboardService.profileVisitsCoursebyMeId(_this.query).subscribe(function (data) {
                    _this.coursebyMe = data;
                    //window.print();
                }, function (err) { return console.log(err); });
            }, function (err) { return console.log(err); });
        }
    };
    return PrintProfileComponent;
}());
export { PrintProfileComponent };
//# sourceMappingURL=printProfile.component.js.map